import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().min(1, "Email is required").email("Enter a valid email"),
  password: z.string().min(6, "Password must be at least 6 characters"),
});

export type LoginFormInput = z.input<typeof loginSchema>;
export type LoginFormOutput = z.infer<typeof loginSchema>;
